module.exports = __webpack_public_path__ + "static/media/custom-icon.6b270c4a.svg";